export type UserBenefitResponse = Readonly<{
  end_date: string;
  id: number;
  installments_additional_text: string;
  installments_max_amount: number;
  installments_min_value: number;
  is_default: boolean;
  is_prime: boolean;
  logged: boolean;
  product_references: string[];
  rappi_credits_additional_text: string;
  rappi_credits_cap: number;
  rappi_credits_min_value: number;
  rappi_credits_percentage: number;
  rappiaccount_cashback_additional_text: string;
  rappiaccount_cashback_cap: number;
  rappiaccount_cashback_min_value: number;
  rappiaccount_cashback_percentage: number;
  rappicard_cashback_additional_text: string;
  rappicard_cashback_cap: number;
  rappicard_cashback_min_value: number;
  rappicard_cashback_percentage: number;
  start_date: string;
  treatments: Treatments[];
}>;

export type GetUserBenefitsPayload = Readonly<{
  logged: boolean;
  is_prime: boolean;
  treatments: Treatments[];
  product_references: string[];
}>;

export type FinancialPartnersInfoVM = Readonly<{
  totalPrice: number,
  maxAmount: number;
}>

type Treatments = Readonly<{
  split_name: string;
  treatment: string;
}>;

export enum BenefitStyle {
  Combined = 'COMBINED',
  RappiCard = 'RAPPI_CARD',
  Prime = 'PRIME',
  RappiAccount = 'RAPPI_ACCOUNT',
}
